/**
 * Componentes do Stripe Connect no app (T4.4, plano seções 2.6/4.1/4.2).
 * Cada nome tem um par `<nome>.web.tsx` (web) e `<nome>.tsx` (nativo, sem
 * sufixo — o Metro só usa `.native.tsx` quando existe também um `.tsx` ou
 * `.web.tsx` "padrão"; sem isso, `tsc` não resolve o import por especificador
 * nu). Mesmo padrão que o resto do app já usa para dividir web/nativo
 * (`components/vercel-analytics.web.tsx` + `components/vercel-analytics.tsx`,
 * `components/ui/brand-color-picker.web.tsx` + `.tsx`): web pega `.web.tsx`,
 * qualquer outra plataforma cai no `.tsx` bare.
 *
 * - `StripeConnectProvider` + `AccountOnboarding`: cadastro. Usados na etapa
 *   6 do assistente (`ActivationStripeStep`, `payment-activation-screen.tsx`)
 *   e reexportados aqui para "Resolver pendência" (T4.5).
 * - `NotificationBanner`, `AccountManagement`: só exportados por enquanto —
 *   quem usa é Recebimentos (T6.1) e Configurar recebimento (T6.4).
 */
export { StripeConnectProvider } from './stripe-connect-provider';
export { AccountOnboarding, type AccountOnboardingProps } from './account-onboarding';
export {
  NotificationBanner,
  type NotificationBannerProps,
  type NotificationsChangeEvent,
} from './notification-banner';
export { AccountManagement, type AccountManagementProps } from './account-management';
